module.exports = __webpack_public_path__ + "img/smart_o_m_paper_making.81962c11.gif";